// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetHash} from './asset-hash.js'

export class AssetMetadata {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AssetMetadata {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAssetMetadata(bb: flatbuffers.ByteBuffer, obj?: AssetMetadata): AssetMetadata {
    return (obj || new AssetMetadata()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAssetMetadata(bb: flatbuffers.ByteBuffer, obj?: AssetMetadata): AssetMetadata {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AssetMetadata()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  assetHash(obj?: AssetHash): AssetHash | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetHash()).__init(this.bb_pos + offset, this.bb!) : null
  }

  fileName(): string | null
  fileName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  fileName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  mimeType(): string | null
  mimeType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  mimeType(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  fileSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startAssetMetadata(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addAssetHash(builder: flatbuffers.Builder, assetHashOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, assetHashOffset, 0)
  }

  static addFileName(builder: flatbuffers.Builder, fileNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, fileNameOffset, 0)
  }

  static addMimeType(builder: flatbuffers.Builder, mimeTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, mimeTypeOffset, 0)
  }

  static addFileSize(builder: flatbuffers.Builder, fileSize: number) {
    builder.addFieldInt32(3, fileSize, 0)
  }

  static endAssetMetadata(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // asset_hash
    builder.requiredField(offset, 6) // file_name
    builder.requiredField(offset, 8) // mime_type
    return offset
  }

  static createAssetMetadata(
    builder: flatbuffers.Builder,
    assetHashOffset: flatbuffers.Offset,
    fileNameOffset: flatbuffers.Offset,
    mimeTypeOffset: flatbuffers.Offset,
    fileSize: number
  ): flatbuffers.Offset {
    AssetMetadata.startAssetMetadata(builder)
    AssetMetadata.addAssetHash(builder, assetHashOffset)
    AssetMetadata.addFileName(builder, fileNameOffset)
    AssetMetadata.addMimeType(builder, mimeTypeOffset)
    AssetMetadata.addFileSize(builder, fileSize)
    return AssetMetadata.endAssetMetadata(builder)
  }
}
